import LabServiceCollection from "../LabServiceCollection";
import AnalyteResultModel from "@/models/lab/AnalyteResultModel";

export default class AnalyteResultCollection extends LabServiceCollection {
  model() {
    return AnalyteResultModel;
  }

  prepareFilter(CollectionFilter) {
    CollectionFilter.defaultSortAddDesc('created_at');
  }

}
